import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import About from './components/About';
import Services from './components/Services';
import FeaturedCampaigns from './components/FeaturedCampaigns';
import CaseStudy from './components/CaseStudy';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="bg-[#0a0a0a] min-h-screen">
      <Navigation />
      <HeroSection />
      <About />
      <Services />
      <FeaturedCampaigns />
      <CaseStudy />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
